import React from "react";
import { Animate, Stagger } from "../../animations";

function Promise({ promises, heading, description }) {
  return (
    <section className="layout-section pb-0">
      <div className="layout-container">
        <Animate variant="fadeUp">
          <h1 id="heading-large" className="text-center mt-0">
            {heading}
          </h1>
          {description && (
            <p id="dark" className="text-center mb-8 sm:mb-12 max-w-3xl mx-auto">
              {description}
            </p>
          )}
        </Animate>
        <Stagger
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-4"
          variant="fadeUp"
          stagger={100}
        >
          {promises.map((promise, index) => (
            <div
              key={index}
              className="border rounded-md p-4 min-h-[140px] bg-white shadow-sm anim-hover-lift"
            >
              <div className="font-bold flex items-start gap-2 mb-2">
                <img
                  src={promise.image}
                  alt=""
                  className="w-8 h-8 object-contain flex-shrink-0"
                />
                <span>{promise.title}</span>
              </div>
              <p className="text-sm text-gray-600">{promise.description}</p>
            </div>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default Promise;
